import React from 'react'
import { Box } from '@mui/material'
import { colors } from '../constants/colors'
import PremiumIcon from '../images/icons/premium-icon'

export const PremiumSquare = ({ size }: { size: number }) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        background: theme => theme.palette.secondary.main,
        borderRadius: `${Math.min(20, size / 4)}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <PremiumIcon color={colors.WHITE} size={size / 2} />
    </Box>
  )
}
